// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__Ge","cls2":"SimplePaperPodcast-cls2_zUa SimplePaperPodcast-cls1__Ge"};